import React from "react";
import { StatusBar } from "expo-status-bar";
import isEqual from 'react-fast-compare'

const ThemedStatusBar = () => {
	
	return (
		<StatusBar
			style="dark"
		/>
	)
}

export default React.memo( ThemedStatusBar, isEqual );
